/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const RATING_NAME_MAX_LENGTH = 23;
